import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Ellipse1 from '../../../../images/product-assets/Ellipse1.svg';
import { formatText } from '../../../../utils';

const Container = styled.section`
    position: relative;
    overflow: hidden;
`;

const ContentBox = styled.div`
    z-index: 1;
    max-width: 1280px;
    margin: 0 auto;
    padding: 100px 20px;

    @media screen and (max-width: 500px) {
        padding: 54px 16px;
    }
`;

const Heading = styled.h1`
    color: #333;
    font-size: 42px;
    font-weight: 500;
    line-height: 48px;
    text-align: center;

    @media screen and (max-width: 500px) {
        font-size: 24px;
        line-height: 28px;
    }
`;

const GridBox = styled.div`
    margin-top: 64px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 50px;

    @media screen and (max-width: 500px) {
        margin-top: 38px;
        gap: 32px;
    }
`;

const Cards = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    @media screen and (max-width: 500px) {
        justify-content: center;
        align-items: center;
    }
`;

const Icons = styled.img`
    width: 65px;
    height: 65px;
`;

const CardHeading = styled.p`
    font-size: 16px;
    font-weight: 400;
    line-height: 28px;
    color: #333;
    margin-top: 12px;

    span {
        font-weight: 700;
    }

    @media screen and (max-width: 500px) {
        font-size: 14px;
        line-height: 18px;
        margin-top: 32px;
    }
`;

const CardDesc = styled.p`
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    color: #52525b;
    margin-top: 16px;

    @media screen and (max-width: 500px) {
        font-size: 14px;
        line-height: 20px;
        margin-top: 12px;
        text-align: center;
    }
`;

const EllipseOne = styled.img`
    position: absolute;
    right: -7%;
    bottom: 0;
    z-index: -1;

    @media screen and (max-width: 500px) {
        display: none;
    }
`;

const InlineLink = styled.a`
    margin-left: 4px;
    font-weight: 600;
    color: #252963;
`;

function BuildTrust({ cardInfo }) {
    return (
        <Container>
            <ContentBox>
                <Heading>Build trust and security</Heading>
                <GridBox>
                    {cardInfo?.map((card) => (
                        <Cards key={card.id}>
                            <Icons src={card.icon} alt={card.alt} />
                            <CardHeading>{card.title}</CardHeading>
                            <CardDesc>
                                {formatText(card.description)}
                                {card.link && (
                                    <InlineLink href={card.link} target="_blank" rel="noreferrer">
                                        {card.linkText}
                                    </InlineLink>
                                )}
                            </CardDesc>
                        </Cards>
                    ))}
                </GridBox>
            </ContentBox>
            <EllipseOne src={Ellipse1} alt="Ellipse 1" />
        </Container>
    );
}

BuildTrust.propTypes = {
    cardInfo: PropTypes.array,
};

export default BuildTrust;
